import type { User } from 'shared-types';

interface Params {
  user: Pick<User, 'expirationDate' | 'locked'>;
}

const isUserAccountLockedOrExpired = ({ user }: Params) =>
  user.locked ||
  Boolean(user.expirationDate && new Date() > user.expirationDate);

export default isUserAccountLockedOrExpired;
